<template>
    <div>
      <el-dialog
          title='课件操作视频'
          :visible.sync="dialogVisible"
          :width=windowWidth
          @close="closed"
          :top=windowTop
          >
          <div class="preview">
              <video :src="videoUrl" controls></video>
          </div>
          <div style="width: 100%;height: 20px;"></div>
      </el-dialog>
    </div>
  </template>
  
  <script>
  export default {
    name: '',
    props: ['video_url'],
    data () {
      return {
          dialogVisible:false,
          videoUrl:this.video_url,
          windowTop:window.innerWidth < 450 ? '27vh':'11vh',
          windowWidth:window.innerWidth < 450 ? '66vh':'840px',
      }
    },
    components: {},
    created () {},
    mounted () {
      this.dialogVisible = true
    },
    methods: {
      closed(){
          this.dialogVisible = false
          this.$emit('videoClosed')
      },
    }
  }
  </script>
  
  <style lang="less" scoped>
  ::v-deep .el-dialog__header {
      border-bottom: 1px solid #ccc;
      padding: 10px;
      font-weight: 600;
  }
  
  .preview {
      height: 480px;
      video{
        width: 100%;
        height: 100%;
      }
  }
  @media screen and (max-width: 450px) {
    ::v-deep .el-dialog {
        transform: rotate(90deg);
        margin: 0 auto;
        height: 100vw;
    }
    .preview {
        height: 85vw;
    }
    ::v-deep .el-dialog__header {
        padding: 5px 24px;
        .el-dialog__title{
            font-size: 3vw;
        }
        .el-dialog__headerbtn{
            top: 7px;
        }
    }

    ::v-deep .el-dialog__body {
        padding: 5px;
    }

}
  </style>
  
